import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Philosophy } from "@/components/Philosophy";
import { Journey } from "@/components/Journey";
import { Programmes } from "@/components/Programmes";
import { Team } from "@/components/Team";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";

export default function Landing() {
  return (
    <main className="relative">
      <div className="grain-overlay" aria-hidden="true" />
      <Nav />
      <Hero />
      <Marquee />
      <Philosophy />
      <Journey />
      <Programmes />
      <Team />
      <Contact />
      <Footer />
    </main>
  );
}
